var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    enableBackground: "new",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m14 14c-3.3067 0-6 2.6933-6 6v20c0 3.3067 2.6933 6 6 6h32c3.3067 0 6-2.6933 6-6v-20c0-3.3067-2.6933-6-6-6h-32zm0 2h32c2.2333 0 4 1.7667 4 4v20c0 2.2333-1.7667 4-4 4h-32c-2.2333 0-4-1.7667-4-4v-20c0-2.2333 1.7667-4 4-4z",
    color: "#000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.029 20a1 1 0 0 0-0.73633 0.29297 1 1 0 0 0 0 1.4141l12 12c2.039 2.039 5.3751 2.039 7.4141 0l12-12a1 1 0 0 0 0-1.4141 1 1 0 0 0-1.4141 0l-12 12c-1.2747 1.2747-3.3112 1.2747-4.5859 0l-12-12a1 1 0 0 0-0.67773-0.29297z",
    color: "#000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.613e82ac.svg";
export { ForwardRef as ReactComponent };